[
  {
    "name": "mypbconnect",
    "version": "1.6.0",
    "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend",
    "private": true,
    "dependencies": {
      "@angular/animations": {
        "from": "@angular/animations",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/animations/-/animations-21.2.10.tgz",
        "description": "Angular - animations integration with web-animations",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+animations@21.2.10_@angular+core@21.2.10_@angular+compiler@21.2.10_rxjs@7.8.2_zone.js@0.16.1_/node_modules/@angular/animations"
      },
      "@angular/cdk": {
        "from": "@angular/cdk",
        "version": "21.2.8",
        "resolved": "https://registry.npmjs.org/@angular/cdk/-/cdk-21.2.8.tgz",
        "description": "Angular Material Component Development Kit",
        "license": "MIT",
        "homepage": "https://github.com/angular/components#readme",
        "repository": "https://github.com/angular/components.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+cdk@21.2.8_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler@21._c33e3d2fb8628b22426ebbf9229f7519/node_modules/@angular/cdk"
      },
      "@angular/common": {
        "from": "@angular/common",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/common/-/common-21.2.10.tgz",
        "description": "Angular - commonly needed directives and services",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler@21.2.10_rxjs@7.8.2_zone.js@0.16.1__rxjs@7.8.2/node_modules/@angular/common"
      },
      "@angular/compiler": {
        "from": "@angular/compiler",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/compiler/-/compiler-21.2.10.tgz",
        "description": "Angular - the compiler library",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+compiler@21.2.10/node_modules/@angular/compiler"
      },
      "@angular/core": {
        "from": "@angular/core",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/core/-/core-21.2.10.tgz",
        "description": "Angular - the core framework",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+core@21.2.10_@angular+compiler@21.2.10_rxjs@7.8.2_zone.js@0.16.1/node_modules/@angular/core"
      },
      "@angular/forms": {
        "from": "@angular/forms",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/forms/-/forms-21.2.10.tgz",
        "description": "Angular - directives and services for creating forms",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+forms@21.2.10_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler@_3427c0775433f251de05d017a6bcde72/node_modules/@angular/forms"
      },
      "@angular/localize": {
        "from": "@angular/localize",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/localize/-/localize-21.2.10.tgz",
        "description": "Angular - library for localizing messages",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+localize@21.2.10_@angular+compiler-cli@21.2.10_@angular+compiler@21.2.10_types_16f7f570d1655e174046553bb3a3d1b7/node_modules/@angular/localize"
      },
      "@angular/material": {
        "from": "@angular/material",
        "version": "21.2.8",
        "resolved": "https://registry.npmjs.org/@angular/material/-/material-21.2.8.tgz",
        "description": "Angular Material",
        "license": "MIT",
        "homepage": "https://github.com/angular/components#readme",
        "repository": "https://github.com/angular/components.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+material@21.2.8_8c1ad9b2cc7451064b682725ce6c5df4/node_modules/@angular/material"
      },
      "@angular/material-luxon-adapter": {
        "from": "@angular/material-luxon-adapter",
        "version": "21.2.8",
        "resolved": "https://registry.npmjs.org/@angular/material-luxon-adapter/-/material-luxon-adapter-21.2.8.tgz",
        "description": "Angular Material Luxon Adapter",
        "license": "MIT",
        "homepage": "https://github.com/angular/components#readme",
        "repository": "https://github.com/angular/components.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+material-luxon-adapter@21.2.8_@angular+core@21.2.10_@angular+compiler@21.2.10__30b09a78555c1651390d754bf2736343/node_modules/@angular/material-luxon-adapter"
      },
      "@angular/platform-browser": {
        "from": "@angular/platform-browser",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/platform-browser/-/platform-browser-21.2.10.tgz",
        "description": "Angular - library for using Angular in a web browser",
        "license": "MIT",
        "author": "angular",
        "repository": "https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+platform-browser@21.2.10_@angular+animations@21.2.10_@angular+core@21.2.10_@an_4821471bcc665bb98d7f30a136527020/node_modules/@angular/platform-browser"
      },
      "@angular/router": {
        "from": "@angular/router",
        "version": "21.2.10",
        "resolved": "https://registry.npmjs.org/@angular/router/-/router-21.2.10.tgz",
        "description": "Angular - the routing library",
        "license": "MIT",
        "author": "angular",
        "homepage": "https://github.com/angular/angular/tree/main/packages/router",
        "repository": "git+https://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@angular+router@21.2.10_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler_0e61b2044884834f4564e90e1ce144fa/node_modules/@angular/router"
      },
      "@fontsource/caveat": {
        "from": "@fontsource/caveat",
        "version": "5.3.0",
        "resolved": "https://registry.npmjs.org/@fontsource/caveat/-/caveat-5.3.0.tgz",
        "description": "Self-host the Caveat font in a neatly bundled NPM package.",
        "license": "OFL-1.1",
        "author": "Google Inc.",
        "homepage": "https://fontsource.org/fonts/caveat",
        "repository": "git+https://github.com/fontsource/font-files.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@fontsource+caveat@5.3.0/node_modules/@fontsource/caveat"
      },
      "@fontsource/dancing-script": {
        "from": "@fontsource/dancing-script",
        "version": "5.3.0",
        "resolved": "https://registry.npmjs.org/@fontsource/dancing-script/-/dancing-script-5.3.0.tgz",
        "description": "Self-host the Dancing Script font in a neatly bundled NPM package.",
        "license": "OFL-1.1",
        "author": "Google Inc.",
        "homepage": "https://fontsource.org/fonts/dancing-script",
        "repository": "git+https://github.com/fontsource/font-files.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@fontsource+dancing-script@5.3.0/node_modules/@fontsource/dancing-script"
      },
      "@fontsource/great-vibes": {
        "from": "@fontsource/great-vibes",
        "version": "5.3.0",
        "resolved": "https://registry.npmjs.org/@fontsource/great-vibes/-/great-vibes-5.3.0.tgz",
        "description": "Self-host the Great Vibes font in a neatly bundled NPM package.",
        "license": "OFL-1.1",
        "author": "Google Inc.",
        "homepage": "https://fontsource.org/fonts/great-vibes",
        "repository": "git+https://github.com/fontsource/font-files.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@fontsource+great-vibes@5.3.0/node_modules/@fontsource/great-vibes"
      },
      "@fontsource/pacifico": {
        "from": "@fontsource/pacifico",
        "version": "5.3.0",
        "resolved": "https://registry.npmjs.org/@fontsource/pacifico/-/pacifico-5.3.0.tgz",
        "description": "Self-host the Pacifico font in a neatly bundled NPM package.",
        "license": "OFL-1.1",
        "author": "Google Inc.",
        "homepage": "https://fontsource.org/fonts/pacifico",
        "repository": "git+https://github.com/fontsource/font-files.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@fontsource+pacifico@5.3.0/node_modules/@fontsource/pacifico"
      },
      "@fontsource/satisfy": {
        "from": "@fontsource/satisfy",
        "version": "5.3.0",
        "resolved": "https://registry.npmjs.org/@fontsource/satisfy/-/satisfy-5.3.0.tgz",
        "description": "Self-host the Satisfy font in a neatly bundled NPM package.",
        "license": "Apache-2.0",
        "author": "Google Inc.",
        "homepage": "https://fontsource.org/fonts/satisfy",
        "repository": "git+https://github.com/fontsource/font-files.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@fontsource+satisfy@5.3.0/node_modules/@fontsource/satisfy"
      },
      "@ng-bootstrap/ng-bootstrap": {
        "from": "@ng-bootstrap/ng-bootstrap",
        "version": "20.0.0",
        "resolved": "https://registry.npmjs.org/@ng-bootstrap/ng-bootstrap/-/ng-bootstrap-20.0.0.tgz",
        "description": "Angular powered Bootstrap",
        "license": "MIT",
        "author": "https://github.com/ng-bootstrap/ng-bootstrap/graphs/contributors",
        "homepage": "https://github.com/ng-bootstrap/ng-bootstrap#readme",
        "repository": "git+https://github.com/ng-bootstrap/ng-bootstrap.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ng-bootstrap+ng-bootstrap@20.0.0_@angular+common@21.2.10_@angular+core@21.2.10_@angula_d2b6e0e48b14e36fdfb233127eca0ecb/node_modules/@ng-bootstrap/ng-bootstrap"
      },
      "@ng-select/ng-select": {
        "from": "@ng-select/ng-select",
        "version": "21.8.0",
        "resolved": "https://registry.npmjs.org/@ng-select/ng-select/-/ng-select-21.8.0.tgz",
        "description": "Angular ng-select - All in One UI Select, Multiselect and Autocomplete",
        "license": "MIT",
        "author": "@ng-select/ng-select",
        "repository": "ng-select/ng-select",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ng-select+ng-select@21.8.0_@angular+common@21.2.10_@angular+core@21.2.10_@angular+comp_ee1a732e7ed661082c4dd7a8984de725/node_modules/@ng-select/ng-select"
      },
      "@ngx-loading-bar/core": {
        "from": "@ngx-loading-bar/core",
        "version": "7.0.1",
        "resolved": "https://registry.npmjs.org/@ngx-loading-bar/core/-/core-7.0.1.tgz",
        "description": "Automatic page loading / progress bar for Angular",
        "license": "MIT",
        "repository": "https://github.com/aitboudad/ngx-loading-bar.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ngx-loading-bar+core@7.0.1_@angular+common@21.2.10_@angular+core@21.2.10_@angular+comp_16ee1535b9652446d7f93794c47768f4/node_modules/@ngx-loading-bar/core"
      },
      "@ngx-loading-bar/http-client": {
        "from": "@ngx-loading-bar/http-client",
        "version": "7.0.1",
        "resolved": "https://registry.npmjs.org/@ngx-loading-bar/http-client/-/http-client-7.0.1.tgz",
        "description": "Automatic page loading / progress bar for Angular",
        "license": "MIT",
        "repository": "https://github.com/aitboudad/ngx-loading-bar.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ngx-loading-bar+http-client@7.0.1_@ngx-loading-bar+core@7.0.1_@angular+common@21.2.10__c26be7f2c3d2149692258356c8d1a0e2/node_modules/@ngx-loading-bar/http-client"
      },
      "@ngx-translate/core": {
        "from": "@ngx-translate/core",
        "version": "17.0.0",
        "resolved": "https://registry.npmjs.org/@ngx-translate/core/-/core-17.0.0.tgz",
        "description": "Translation library (i18n) for Angular",
        "license": "MIT",
        "author": "Andreas Löw / CodeAndWeb GmbH, Olivier Combe",
        "homepage": "https://github.com/ngx-translate/core#readme",
        "repository": "https://github.com/ngx-translate/core",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ngx-translate+core@17.0.0_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compi_ee47c76feb8029ecde073dbfd44b597e/node_modules/@ngx-translate/core"
      },
      "@ngx-translate/http-loader": {
        "from": "@ngx-translate/http-loader",
        "version": "17.0.0",
        "resolved": "https://registry.npmjs.org/@ngx-translate/http-loader/-/http-loader-17.0.0.tgz",
        "description": "http loader for dynamically loading translation files for @ngx-translate/core",
        "license": "MIT",
        "author": "Andreas Löw / CodeAndWeb GmbH, Olivier Combe",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@ngx-translate+http-loader@17.0.0_@angular+common@21.2.10_@angular+core@21.2.10_@angula_ff12fd1e9e279b3d9b870b21882ccf0d/node_modules/@ngx-translate/http-loader"
      },
      "@pb-design-system/pb-design-system": {
        "from": "@pb-design-system/pb-design-system",
        "version": "19.0.0-beta.0",
        "resolved": "https://registry.npmjs.org/@pb-design-system/pb-design-system/-/pb-design-system-19.0.0-beta.0.tgz",
        "description": "Pitney Bowes Design System",
        "license": "MIT",
        "author": "Pitney Bowes",
        "homepage": "https://gitlab.com/pitneybowes/innovation/common/design-system/ng-designsystem",
        "repository": "https://gitlab.com/pitneybowes/innovation/common/design-system/ng-designsystem.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@pb-design-system+pb-design-system@19.0.0-beta.0_49ece66122f7b72d8ea275a2845fd20c/node_modules/@pb-design-system/pb-design-system"
      },
      "@popperjs/core": {
        "from": "@popperjs/core",
        "version": "2.11.8",
        "resolved": "https://registry.npmjs.org/@popperjs/core/-/core-2.11.8.tgz",
        "description": "Tooltip and Popover Positioning Engine",
        "license": "MIT",
        "author": "Federico Zivolo <federico.zivolo@gmail.com>",
        "repository": "github:popperjs/popper-core",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core"
      },
      "amazon-cognito-identity-js": {
        "from": "amazon-cognito-identity-js",
        "version": "6.3.16",
        "resolved": "https://registry.npmjs.org/amazon-cognito-identity-js/-/amazon-cognito-identity-js-6.3.16.tgz",
        "description": "Amazon Cognito Identity Provider JavaScript SDK",
        "license": "Apache-2.0",
        "author": {
          "name": "Amazon Web Services",
          "email": "aws@amazon.com",
          "url": "http://aws.amazon.com"
        },
        "homepage": "http://aws.amazon.com/cognito",
        "repository": "https://github.com/aws-amplify/amplify-js.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/amazon-cognito-identity-js@6.3.16/node_modules/amazon-cognito-identity-js"
      },
      "amazon-quicksight-embedding-sdk": {
        "from": "amazon-quicksight-embedding-sdk",
        "version": "2.11.3",
        "resolved": "https://registry.npmjs.org/amazon-quicksight-embedding-sdk/-/amazon-quicksight-embedding-sdk-2.11.3.tgz",
        "description": "JS SDK for embedding Amazon QuickSight",
        "license": "Apache-2.0",
        "author": {
          "name": "QuickSight",
          "url": "https://aws.amazon.com/quicksight/"
        },
        "homepage": "https://github.com/awslabs/amazon-quicksight-embedding-sdk",
        "repository": "git@github.com:awslabs/amazon-quicksight-embedding-sdk.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/amazon-quicksight-embedding-sdk@2.11.3/node_modules/amazon-quicksight-embedding-sdk"
      },
      "bootstrap": {
        "from": "bootstrap",
        "version": "5.3.8",
        "resolved": "https://registry.npmjs.org/bootstrap/-/bootstrap-5.3.8.tgz",
        "description": "The most popular front-end framework for developing responsive, mobile first projects on the web.",
        "license": "MIT",
        "author": "The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)",
        "homepage": "https://getbootstrap.com/",
        "repository": "git+https://github.com/twbs/bootstrap.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/bootstrap@5.3.8_@popperjs+core@2.11.8/node_modules/bootstrap"
      },
      "buffer": {
        "from": "buffer",
        "version": "6.0.3",
        "resolved": "https://registry.npmjs.org/buffer/-/buffer-6.0.3.tgz",
        "description": "Node.js Buffer API, for the browser",
        "license": "MIT",
        "author": {
          "name": "Feross Aboukhadijeh",
          "email": "feross@feross.org",
          "url": "https://feross.org"
        },
        "homepage": "https://github.com/feross/buffer",
        "repository": "git://github.com/feross/buffer.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/buffer@6.0.3/node_modules/buffer"
      },
      "chardet": {
        "from": "chardet",
        "version": "2.1.1",
        "resolved": "https://registry.npmjs.org/chardet/-/chardet-2.1.1.tgz",
        "description": "Character encoding detector",
        "license": "MIT",
        "author": "Dmitry Shirokov <deadrunk@gmail.com>",
        "homepage": "https://github.com/runk/node-chardet",
        "repository": "https://github.com/runk/node-chardet.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/chardet@2.1.1/node_modules/chardet"
      },
      "chart.js": {
        "from": "chart.js",
        "version": "4.5.1",
        "resolved": "https://registry.npmjs.org/chart.js/-/chart.js-4.5.1.tgz",
        "description": "Simple HTML5 charts using the canvas element.",
        "license": "MIT",
        "homepage": "https://www.chartjs.org",
        "repository": "https://github.com/chartjs/Chart.js.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/chart.js@4.5.1/node_modules/chart.js"
      },
      "chartjs-plugin-datalabels": {
        "from": "chartjs-plugin-datalabels",
        "version": "2.2.0",
        "resolved": "https://registry.npmjs.org/chartjs-plugin-datalabels/-/chartjs-plugin-datalabels-2.2.0.tgz",
        "description": "Chart.js plugin to display labels on data elements",
        "license": "MIT",
        "homepage": "https://chartjs-plugin-datalabels.netlify.app",
        "repository": "https://github.com/chartjs/chartjs-plugin-datalabels.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/chartjs-plugin-datalabels@2.2.0_chart.js@4.5.1/node_modules/chartjs-plugin-datalabels"
      },
      "detect-file-encoding-and-language": {
        "from": "detect-file-encoding-and-language",
        "version": "2.4.0",
        "resolved": "https://registry.npmjs.org/detect-file-encoding-and-language/-/detect-file-encoding-and-language-2.4.0.tgz",
        "description": "Charset Detector - Detect the encoding and language of text files - Use it in the browser, with Node.js, or via CLI",
        "license": "MIT",
        "author": "Linus Komnick",
        "homepage": "https://github.com/gignupg/Detect-File-Encoding-and-Language#readme",
        "repository": "git+https://github.com/gignupg/Detect-File-Encoding-And-Language.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/detect-file-encoding-and-language@2.4.0/node_modules/detect-file-encoding-and-language"
      },
      "docxtemplater": {
        "from": "docxtemplater",
        "version": "3.68.5",
        "resolved": "https://registry.npmjs.org/docxtemplater/-/docxtemplater-3.68.5.tgz",
        "description": "Generate docx, pptx, and xlsx from templates (Word, Powerpoint and Excel documents), from Node.js, the Browser and the command line",
        "license": "MIT",
        "author": "Edgar Hipp",
        "repository": "git+https://github.com/open-xml-templating/docxtemplater.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/docxtemplater@3.68.5/node_modules/docxtemplater"
      },
      "file-saver": {
        "from": "file-saver",
        "version": "2.0.5",
        "resolved": "https://registry.npmjs.org/file-saver/-/file-saver-2.0.5.tgz",
        "description": "An HTML5 saveAs() FileSaver implementation",
        "license": "MIT",
        "author": "Eli Grey <me@eligrey.com>",
        "homepage": "https://github.com/eligrey/FileSaver.js#readme",
        "repository": "https://github.com/eligrey/FileSaver.js",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/file-saver@2.0.5/node_modules/file-saver"
      },
      "html2canvas": {
        "from": "html2canvas",
        "version": "1.4.1",
        "resolved": "https://registry.npmjs.org/html2canvas/-/html2canvas-1.4.1.tgz",
        "description": "Screenshots with JavaScript",
        "license": "MIT",
        "author": {
          "name": "Niklas von Hertzen",
          "email": "niklasvh@gmail.com",
          "url": "https://hertzen.com"
        },
        "homepage": "https://html2canvas.hertzen.com",
        "repository": "git@github.com:niklasvh/html2canvas.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/html2canvas@1.4.1/node_modules/html2canvas"
      },
      "iconv-lite": {
        "from": "iconv-lite",
        "version": "0.7.2",
        "resolved": "https://registry.npmjs.org/iconv-lite/-/iconv-lite-0.7.2.tgz",
        "description": "Convert character encodings in pure javascript.",
        "license": "MIT",
        "author": "Alexander Shtuchkin <ashtuchkin@gmail.com>",
        "homepage": "https://github.com/pillarjs/iconv-lite",
        "repository": "https://github.com/pillarjs/iconv-lite.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/iconv-lite@0.7.2/node_modules/iconv-lite"
      },
      "jschardet": {
        "from": "jschardet",
        "version": "3.1.4",
        "resolved": "https://registry.npmjs.org/jschardet/-/jschardet-3.1.4.tgz",
        "description": "Character encoding auto-detection in JavaScript (port of python's chardet)",
        "license": "LGPL-2.1+",
        "author": "António Afonso",
        "repository": "https://github.com/aadsm/jschardet.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/jschardet@3.1.4/node_modules/jschardet"
      },
      "jspdf": {
        "from": "jspdf",
        "version": "4.2.1",
        "resolved": "https://registry.npmjs.org/jspdf/-/jspdf-4.2.1.tgz",
        "description": "PDF Document creation from JavaScript",
        "license": "MIT",
        "homepage": "https://github.com/parallax/jsPDF",
        "repository": "https://github.com/parallax/jsPDF.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/jspdf@4.2.1/node_modules/jspdf"
      },
      "jspdf-autotable": {
        "from": "jspdf-autotable",
        "version": "5.0.7",
        "resolved": "https://registry.npmjs.org/jspdf-autotable/-/jspdf-autotable-5.0.7.tgz",
        "description": "Generate pdf tables with javascript (jsPDF plugin)",
        "license": "MIT",
        "author": "Simon Bengtsson <dev@simonbengtsson.com>",
        "homepage": "https://simonbengtsson.github.io/jsPDF-AutoTable",
        "repository": "https://github.com/simonbengtsson/jsPDF-AutoTable.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/jspdf-autotable@5.0.7_jspdf@4.2.1/node_modules/jspdf-autotable"
      },
      "jszip": {
        "from": "jszip",
        "version": "3.10.1",
        "resolved": "https://registry.npmjs.org/jszip/-/jszip-3.10.1.tgz",
        "description": "Create, read and edit .zip files with JavaScript http://stuartk.com/jszip",
        "license": "(MIT OR GPL-3.0-or-later)",
        "author": "Stuart Knightley <stuart@stuartk.com>",
        "repository": "https://github.com/Stuk/jszip.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/jszip@3.10.1/node_modules/jszip"
      },
      "lodash-es": {
        "from": "lodash-es",
        "version": "4.18.1",
        "resolved": "https://registry.npmjs.org/lodash-es/-/lodash-es-4.18.1.tgz",
        "description": "Lodash exported as ES modules.",
        "license": "MIT",
        "author": "John-David Dalton <john.david.dalton@gmail.com>",
        "homepage": "https://lodash.com/custom-builds",
        "repository": "lodash/lodash",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/lodash-es@4.18.1/node_modules/lodash-es"
      },
      "luxon": {
        "from": "luxon",
        "version": "3.7.2",
        "resolved": "https://registry.npmjs.org/luxon/-/luxon-3.7.2.tgz",
        "description": "Immutable date wrapper",
        "license": "MIT",
        "author": "Isaac Cambron",
        "repository": "https://github.com/moment/luxon",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/luxon@3.7.2/node_modules/luxon"
      },
      "material-icons": {
        "from": "material-icons",
        "version": "1.13.14",
        "resolved": "https://registry.npmjs.org/material-icons/-/material-icons-1.13.14.tgz",
        "description": "Latest icon fonts and CSS for self-hosting material design icons.",
        "license": "Apache-2.0",
        "homepage": "https://marella.github.io/material-icons/demo/",
        "repository": "git+https://github.com/marella/material-icons.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/material-icons@1.13.14/node_modules/material-icons"
      },
      "ng-dynamic-component": {
        "from": "ng-dynamic-component",
        "version": "10.8.2",
        "resolved": "https://registry.npmjs.org/ng-dynamic-component/-/ng-dynamic-component-10.8.2.tgz",
        "license": "MIT",
        "author": "Alex Malkevich <malkevich.alex@gmail.com>",
        "repository": "https://github.com/gund/ng-dynamic-component.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ng-dynamic-component@10.8.2_@angular+common@21.2.10_@angular+core@21.2.10_@angular+comp_1e0326c2dcc385e6caea42ce91676760/node_modules/ng-dynamic-component"
      },
      "ng2-charts": {
        "from": "ng2-charts",
        "version": "10.0.0",
        "resolved": "https://registry.npmjs.org/ng2-charts/-/ng2-charts-10.0.0.tgz",
        "description": "Reactive, responsive, beautiful charts for Angular based on Chart.js",
        "license": "MIT",
        "author": "Dmitriy Shekhovtsov <valorkin@gmail.com>",
        "homepage": "https://github.com/valor-software/ng2-charts#readme",
        "repository": "git+https://github.com/valor-software/ng2-charts.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ng2-charts@10.0.0_ba6a5d15101a1c18223c868dd3746877/node_modules/ng2-charts"
      },
      "ngx-color-picker": {
        "from": "ngx-color-picker",
        "version": "20.1.1",
        "resolved": "https://registry.npmjs.org/ngx-color-picker/-/ngx-color-picker-20.1.1.tgz",
        "description": "Color picker widget for Angular",
        "license": "MIT",
        "repository": "https://github.com/zefoy/ngx-color-picker.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-color-picker@20.1.1_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler_cf24183bc9f54431d60ccfe4a03121cb/node_modules/ngx-color-picker"
      },
      "ngx-csv": {
        "from": "ngx-csv",
        "version": "0.3.2",
        "resolved": "https://registry.npmjs.org/ngx-csv/-/ngx-csv-0.3.2.tgz",
        "description": "Helper library for create CSV file in Angular 2+",
        "license": "MIT",
        "author": "Luke Hanscom",
        "homepage": "https://github.com/lhanscom/ngx-csv/#readme",
        "repository": "https://github.com/lhanscom/ngx-csv.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-csv@0.3.2/node_modules/ngx-csv"
      },
      "ngx-file-drop": {
        "from": "ngx-file-drop",
        "version": "16.0.0",
        "resolved": "https://registry.npmjs.org/ngx-file-drop/-/ngx-file-drop-16.0.0.tgz",
        "description": "Angular ngx-file-drop - Simple desktop file and folder drag and drop",
        "license": "MIT",
        "author": "Georgi Peltekov",
        "repository": "georgipeltekov/ngx-file-drop",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-file-drop@16.0.0_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler@21_61d8d25d1d546a18fe8bca65dcda3e8c/node_modules/ngx-file-drop"
      },
      "ngx-font-picker": {
        "from": "ngx-font-picker",
        "version": "20.1.0",
        "resolved": "https://registry.npmjs.org/ngx-font-picker/-/ngx-font-picker-20.1.0.tgz",
        "description": "Google fonts font picker widget for Angular",
        "license": "MIT",
        "repository": "https://github.com/zefoy/ngx-font-picker.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-font-picker@20.1.0_fc3ab210d33bf467573845a2772d1e1d/node_modules/ngx-font-picker"
      },
      "ngx-infinite-scroll": {
        "from": "ngx-infinite-scroll",
        "version": "21.0.0",
        "resolved": "https://registry.npmjs.org/ngx-infinite-scroll/-/ngx-infinite-scroll-21.0.0.tgz",
        "license": "MIT",
        "homepage": "https://github.com/orizens/ngx-infinite-scroll",
        "repository": "https://github.com/orizens/ngx-infinite-scroll",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-infinite-scroll@21.0.0_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compi_a7f9dfa69c4c1674d41bf6bc4a5912ae/node_modules/ngx-infinite-scroll"
      },
      "ngx-quill": {
        "from": "ngx-quill",
        "version": "30.1.3",
        "resolved": "https://registry.npmjs.org/ngx-quill/-/ngx-quill-30.1.3.tgz",
        "description": "Angular components for the easy use of the QuillJS richt text editor.",
        "license": "MIT",
        "author": {
          "name": "Bengt Weiße"
        },
        "homepage": "https://github.com/KillerCodeMonkey/ngx-quill",
        "repository": "https://github.com/KillerCodeMonkey/ngx-quill",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-quill@30.1.3_@angular+core@21.2.10_@angular+compiler@21.2.10_rxjs@7.8.2_zone.js@0.16.1__quill@2.0.3_rxjs@7.8.2/node_modules/ngx-quill"
      },
      "ngx-toastr": {
        "from": "ngx-toastr",
        "version": "20.0.5",
        "resolved": "https://registry.npmjs.org/ngx-toastr/-/ngx-toastr-20.0.5.tgz",
        "license": "MIT",
        "repository": "https://github.com/scttcper/ngx-toastr",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/ngx-toastr@20.0.5_@angular+common@21.2.10_@angular+core@21.2.10_@angular+compiler@21.2._a8129f9797ef3eab92f3240d449b2485/node_modules/ngx-toastr"
      },
      "papaparse": {
        "from": "papaparse",
        "version": "5.5.3",
        "resolved": "https://registry.npmjs.org/papaparse/-/papaparse-5.5.3.tgz",
        "description": "Fast and powerful CSV parser for the browser that supports web workers and streaming large files. Converts CSV to JSON and JSON to CSV.",
        "license": "MIT",
        "author": {
          "name": "Matthew Holt",
          "url": "https://twitter.com/mholt6"
        },
        "homepage": "https://www.papaparse.com/",
        "repository": "git+https://github.com/mholt/PapaParse.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/papaparse@5.5.3/node_modules/papaparse"
      },
      "pdf-lib": {
        "from": "pdf-lib",
        "version": "1.17.1",
        "resolved": "https://registry.npmjs.org/pdf-lib/-/pdf-lib-1.17.1.tgz",
        "description": "Create and modify PDF files with JavaScript",
        "license": "MIT",
        "author": "Andrew Dillon <andrew.dillon.j@gmail.com>",
        "homepage": "https://pdf-lib.js.org",
        "repository": "git+https://github.com/Hopding/pdf-lib.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/pdf-lib@1.17.1/node_modules/pdf-lib"
      },
      "pdfjs-dist": {
        "from": "pdfjs-dist",
        "version": "5.6.205",
        "resolved": "https://registry.npmjs.org/pdfjs-dist/-/pdfjs-dist-5.6.205.tgz",
        "description": "Generic build of Mozilla's PDF.js library.",
        "license": "Apache-2.0",
        "homepage": "https://mozilla.github.io/pdf.js/",
        "repository": "git+https://github.com/mozilla/pdf.js.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/pdfjs-dist@5.6.205/node_modules/pdfjs-dist"
      },
      "pdfobject": {
        "from": "pdfobject",
        "version": "2.3.1",
        "resolved": "https://registry.npmjs.org/pdfobject/-/pdfobject-2.3.1.tgz",
        "description": "A lightweight JavaScript utility for dynamically embedding PDFs in HTML documents",
        "license": "MIT",
        "author": "Philip Hutchison <philip@pipwerks.com> (http://pipwerks.com)",
        "homepage": "https://github.com/pipwerks/PDFObject#readme",
        "repository": "git+https://pipwerks@github.com/pipwerks/PDFObject.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/pdfobject@2.3.1/node_modules/pdfobject"
      },
      "pizzip": {
        "from": "pizzip",
        "version": "3.2.0",
        "resolved": "https://registry.npmjs.org/pizzip/-/pizzip-3.2.0.tgz",
        "description": "Create, read and edit .zip files synchronously with Javascript",
        "license": "(MIT OR GPL-3.0)",
        "author": "Edgar Hipp",
        "repository": "https://github.com/open-xml-templating/pizzip",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/pizzip@3.2.0/node_modules/pizzip"
      },
      "postal-codes-js": {
        "from": "postal-codes-js",
        "version": "2.5.2",
        "resolved": "https://registry.npmjs.org/postal-codes-js/-/postal-codes-js-2.5.2.tgz",
        "description": "Postal Codes",
        "license": "Apache-2.0",
        "author": "Ozan Kaya, Ivan Stanishev",
        "homepage": "https://github.com/Cimpress-MCP/postal-codes-js#readme",
        "repository": "git+https://github.com/Cimpress-MCP/postal-codes-js.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/postal-codes-js@2.5.2/node_modules/postal-codes-js"
      },
      "postal-mime": {
        "from": "postal-mime",
        "version": "2.7.4",
        "resolved": "https://registry.npmjs.org/postal-mime/-/postal-mime-2.7.4.tgz",
        "description": "Email parser for Node.js and browser environments",
        "license": "MIT-0",
        "author": "Andris Reinman",
        "homepage": "https://postal-mime.postalsys.com",
        "repository": "git+https://github.com/postalsys/postal-mime.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/postal-mime@2.7.4/node_modules/postal-mime"
      },
      "primeflex": {
        "from": "primeflex",
        "version": "4.0.0",
        "resolved": "https://registry.npmjs.org/primeflex/-/primeflex-4.0.0.tgz",
        "description": "PrimeFlex is a lightweight responsive CSS utility library to accompany Prime UI libraries and static webpages as well.",
        "license": "MIT",
        "author": "PrimeTek",
        "homepage": "https://primeflex.org",
        "repository": "git+https://github.com/primefaces/primeflex.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/primeflex@4.0.0/node_modules/primeflex"
      },
      "primeicons": {
        "from": "primeicons",
        "version": "7.0.0",
        "resolved": "https://registry.npmjs.org/primeicons/-/primeicons-7.0.0.tgz",
        "description": "Icon Library for Prime UI Libraries",
        "license": "MIT",
        "author": "PrimeTek",
        "homepage": "https://github.com/primefaces/primeicons#readme",
        "repository": "git+https://github.com/primefaces/primeicons.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/primeicons@7.0.0/node_modules/primeicons"
      },
      "primeng": {
        "from": "primeng",
        "version": "21.1.6",
        "resolved": "https://registry.npmjs.org/primeng/-/primeng-21.1.6.tgz",
        "description": "PrimeNG is an open source UI library for Angular featuring a rich set of 80+ components, a theme designer, various theme alternatives such as Material, Bootstrap, Tailwind, premium templates and professional support. In addition, it integrates with PrimeBlock, which has 370+ ready to use UI blocks to build spectacular applications in no time.",
        "license": "SEE LICENSE IN LICENSE.md",
        "author": "PrimeTek Informatics",
        "homepage": "https://primeng.org/",
        "repository": "https://github.com/primefaces/primeng.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/primeng@21.1.6_922032978263644f85fbfd03461478b6/node_modules/primeng"
      },
      "qrcode": {
        "from": "qrcode",
        "version": "1.5.4",
        "resolved": "https://registry.npmjs.org/qrcode/-/qrcode-1.5.4.tgz",
        "description": "QRCode / 2d Barcode api with both server side and client side support using canvas",
        "license": "MIT",
        "author": "Ryan Day <soldair@gmail.com>",
        "homepage": "http://github.com/soldair/node-qrcode",
        "repository": "git://github.com/soldair/node-qrcode.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/qrcode@1.5.4/node_modules/qrcode"
      },
      "quill": {
        "from": "quill",
        "version": "2.0.3",
        "resolved": "https://registry.npmjs.org/quill/-/quill-2.0.3.tgz",
        "description": "Your powerful, rich text editor",
        "license": "BSD-3-Clause",
        "author": "Jason Chen <jhchen7@gmail.com>",
        "homepage": "https://quilljs.com",
        "repository": "git+https://github.com/slab/quill.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/quill@2.0.3/node_modules/quill"
      },
      "rxjs": {
        "from": "rxjs",
        "version": "7.8.2",
        "resolved": "https://registry.npmjs.org/rxjs/-/rxjs-7.8.2.tgz",
        "description": "Reactive Extensions for modern JavaScript",
        "license": "Apache-2.0",
        "author": "Ben Lesh <ben@benlesh.com>",
        "homepage": "https://rxjs.dev",
        "repository": "https://github.com/reactivex/rxjs.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/rxjs@7.8.2/node_modules/rxjs"
      },
      "sass": {
        "from": "sass",
        "version": "1.99.0",
        "resolved": "https://registry.npmjs.org/sass/-/sass-1.99.0.tgz",
        "description": "A pure JavaScript implementation of Sass.",
        "license": "MIT",
        "author": {
          "name": "Natalie Weizenbaum",
          "email": "nweiz@google.com",
          "url": "https://github.com/nex3"
        },
        "homepage": "https://github.com/sass/dart-sass",
        "repository": "https://github.com/sass/dart-sass",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/sass@1.99.0/node_modules/sass"
      },
      "tesseract.js": {
        "from": "tesseract.js",
        "version": "7.0.0",
        "resolved": "https://registry.npmjs.org/tesseract.js/-/tesseract.js-7.0.0.tgz",
        "description": "Pure Javascript Multilingual OCR",
        "license": "Apache-2.0",
        "author": "",
        "homepage": "https://github.com/naptha/tesseract.js",
        "repository": "https://github.com/naptha/tesseract.js.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/tesseract.js@7.0.0/node_modules/tesseract.js"
      },
      "tesseract.js-core": {
        "from": "tesseract.js-core",
        "version": "7.0.0",
        "resolved": "https://registry.npmjs.org/tesseract.js-core/-/tesseract.js-core-7.0.0.tgz",
        "description": "Tesseract C++ API in Pure Javascript",
        "license": "Apache-2.0",
        "author": "antimatter15",
        "homepage": "https://github.com/naptha/tesseract.js-core",
        "repository": "https://github.com/naptha/tesseract.js-core.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/tesseract.js-core@7.0.0/node_modules/tesseract.js-core"
      },
      "tslib": {
        "from": "tslib",
        "version": "2.8.1",
        "resolved": "https://registry.npmjs.org/tslib/-/tslib-2.8.1.tgz",
        "description": "Runtime library for TypeScript helper functions",
        "license": "0BSD",
        "author": "Microsoft Corp.",
        "homepage": "https://www.typescriptlang.org/",
        "repository": "https://github.com/Microsoft/tslib.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/tslib@2.8.1/node_modules/tslib"
      },
      "uuid": {
        "from": "uuid",
        "version": "14.0.0",
        "resolved": "https://registry.npmjs.org/uuid/-/uuid-14.0.0.tgz",
        "description": "RFC9562 UUIDs",
        "license": "MIT",
        "repository": "https://github.com/uuidjs/uuid.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/uuid@14.0.0/node_modules/uuid"
      },
      "zone.js": {
        "from": "zone.js",
        "version": "0.16.1",
        "resolved": "https://registry.npmjs.org/zone.js/-/zone.js-0.16.1.tgz",
        "description": "Zones for JavaScript",
        "license": "MIT",
        "author": "Brian Ford",
        "repository": "git://github.com/angular/angular.git",
        "path": "/builds/pitneybowes/innovation/solutions-france/mypbconnect/frontend/node_modules/.pnpm/zone.js@0.16.1/node_modules/zone.js"
      }
    }
  }
]
